import SlideShow from 'slide-show';

class ImageSlider extends SlideShow
{
	initialize()
	{
		//Custom slider arrows
		this.backSlider = this.itemContainer.querySelector('.slider-arrow.left') || null;
		this.forwardSlider = this.itemContainer.querySelector('.slider-arrow.right') || null;
		
		//This is simply so we don't use the default slider arrows from slide-show.js these do not work for the DOM layout
		this.addControlSliders = false; 
		
		this.slideshowContainer = this.itemContainer;
		
		this.itemContainer = this.itemContainer.querySelector('div.imageSlider');
		
		super.initialize();
		
		this.itemContainer.classList.remove('slider');
		this.itemContainer.classList.add('imageSlider');
		
		this.sliderContainer.classList.remove('sliderContainer');
		this.sliderContainer.classList.add('imageContainer');
		
		this.autoSlideInterval = parseInt(this.slideshowContainer.dataset.autoSlideInterval) || 0;
		
		if(this.autoSlideInterval !== 0) super.autoScroll(this.autoSlideInterval);
	}
}

export default ImageSlider;
